import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UnsubscribeService } from '@libs/shared/services/unsubscribe.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-verification-video-callback',
  templateUrl: './verification-video-callback.component.html',
  styleUrls: ['./verification-video-callback.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  providers: [UnsubscribeService],
  imports: [TranslateModule],
})
export class VerificationVideoCallbackComponent {}
